export function isVNodeCreatedByComponent(vnode, componentInstance) {
    return vnode.componentOptions && vnode.componentOptions.Ctor.options.name === componentInstance.name;
}
